import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { RoutePlanner } from './components/RoutePlanner'
import { SavedRoutes } from './components/SavedRoutes'
import { RouteHistory } from './components/RouteHistory'
import { Route, Star, History } from 'lucide-react'

export function Routing() {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <main className="flex-1 overflow-auto p-6">
          <div className="max-w-7xl mx-auto space-y-6">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">Routing & Optimization</h1>
              <p className="text-muted-foreground">
                Plan routes, optimize multi-stop deliveries, and track routing history
              </p>
            </div>

            <Tabs defaultValue="planner" className="space-y-6">
              <TabsList className="grid w-full max-w-2xl grid-cols-3">
                <TabsTrigger value="planner" className="gap-2">
                  <Route className="h-4 w-4" />
                  Route Planner
                </TabsTrigger>
                <TabsTrigger value="saved" className="gap-2">
                  <Star className="h-4 w-4" />
                  Saved Routes
                </TabsTrigger>
                <TabsTrigger value="history" className="gap-2">
                  <History className="h-4 w-4" />
                  History
                </TabsTrigger>
              </TabsList>

              <TabsContent value="planner" className="space-y-6">
                <RoutePlanner />
              </TabsContent>

              <TabsContent value="saved" className="space-y-6">
                <SavedRoutes />
              </TabsContent>

              <TabsContent value="history" className="space-y-6">
                <RouteHistory />
              </TabsContent>
            </Tabs>
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
